











import { Component, Vue } from 'vue-property-decorator';
import env from '@/env';
import axios, { AxiosResponse } from 'axios';
import { Attribute } from '@/interfaces/Attribute';
import { Category } from '@/interfaces/Category';
import AttributeCategorizedList from '@/components/Attributes/AttributeCategorizedList.vue';

@Component({
  components: {
    AttributeCategorizedList
  }
})
export default class AttributesView extends Vue {
  allAttributes: Attribute[] = [];

  attributeCategories: Category[] = [];

  swatches = [
    ['#E8B291', '#C6D7F9'],
    ['#87C8B3', '#E7D3AE']
  ];

  get environments() {
    return [{ id: null, name: 'DEFAULT' }, ...this.$store.state.all_environments];
  }

  refreshingAttributesList = false;

  attributesByCategory: Record<number, Attribute[]> = {};

  attributesByBlueprint: Record<number, Attribute[]> = {};

  async addCategory(event: Event) {
    event.stopPropagation();
    event.preventDefault();

    const { data: category } = await axios.post(`${env.backend_url}/attribute/category`, {
      name: 'Neue Kategorie',
      color: '#FFFFFF'
    });
    this.attributeCategories.push(category);
  }

  async save() {
    const promises: Promise<AxiosResponse>[] = [];
    this.attributeCategories.forEach((category) => {
      if (!category.id) return;
      promises.push(axios.put(`${env.backend_url}/attribute/category`, category));
    });

    this.allAttributes.forEach((parentAttribute: Attribute) => {
      promises.push(axios.post(`${env.backend_url}/attribute/update`, parentAttribute));
    });
    return Promise.all(promises);
  }

  async changeCategoryOfAttribute(attribute: Attribute, category: Category) {
    const index = this.attributesByCategory[attribute.category_id as number].indexOf(attribute);
    this.attributesByCategory[attribute.category_id as number].splice(index, 1);

    if (!this.attributesByCategory[category.id]) this.attributesByCategory[category.id] = [];
    this.attributesByCategory[category.id] = [...this.attributesByCategory[category.id], attribute];
    attribute.category_id = category.id;
  }

  async deleteCategory(category: Category) {
    this.allAttributes.forEach((attribute) => {
      if (attribute.category_id === category.id) {
        attribute.category_id = null;
        this.changeCategoryOfAttribute(attribute, ({ id: 'null' } as unknown) as Category);
      }
    });

    await axios.delete(`${env.backend_url}/attribute/category/${category.id}`);

    const index = this.attributeCategories.indexOf(category);
    this.attributeCategories.splice(index, 1);
  }

  async created() {
    this.$emit('showPreloader');
    const { data: attributes } = await axios.get(`${env.backend_url}/attribute/all/full`);
    this.allAttributes = attributes.filter(
      (attribute: Attribute) =>
        attribute.is_blueprint || (!attribute.is_blueprint && !attribute.blueprint_id)
    );

    const { data: categories } = await axios.get(`${env.backend_url}/attribute/all_categories`);
    this.attributeCategories = [
      {
        id: null,
        name: 'Ohne Kategorie',
        color: 'white'
      },
      ...categories
    ];
    this.attributesByCategory = this.allAttributes.reduce(
      (
        accumulator: Record<number, Attribute[]>,
        currentBlueprint: any
      ): Record<number, Attribute[]> => {
        if (!accumulator[currentBlueprint.category_id])
          accumulator[currentBlueprint.category_id] = [];
        accumulator[currentBlueprint.category_id].push(currentBlueprint);
        return accumulator;
      },
      {}
    );
    this.$emit('loadingFinished');
  }

  tab = 0;
}
